import {
    ArrayModel,
    assignModelOptions,
    ClientManagerInstanceToken,
    CompositeModel,
    ConfigConstants,
    ConfigService,
    CustomInjector,
    MaterialCheckModel,
    ModelOptionsLoaderService,
    NumberModel,
    TextModel,
    UserMasterService,
} from '@evorait/pace-core';

export default class MaterialAvailabilityModel extends CompositeModel {
    public materialNumber: TextModel;
    public quantity: NumberModel;
    public materials: TextModel;
    public partSet: ArrayModel<MaterialCheckModel>;
    public frontId: TextModel;
    public salesOrg: TextModel;
    public plant: TextModel;
    public longText: ArrayModel<TextModel>;
    public constructor() {
        super('MaterialAvailabilityModel');
        const injector = CustomInjector.getInjector();
        const userMasterService = injector.get(UserMasterService);
        const modelOptionsLoader = injector.get(ModelOptionsLoaderService);
        const configService = injector.get(ConfigService);
        const clientManager = injector.get(ClientManagerInstanceToken);

        this.materialNumber = new TextModel('MaterialNumber');
        modelOptionsLoader.load(this.materialNumber, 'MaterialAvailability', 'MaterialNumber');
        this.materialNumber = assignModelOptions(
            this.materialNumber,
            {
                ...this.materialNumber.options,
                applicationIdentifier: ConfigConstants.ApplicationIdentifier.ProductIdentifier,
            },
            this,
        );

        this.quantity = new NumberModel('Quantity', 1);

        this.partSet = <ArrayModel<MaterialCheckModel>>this.set(new ArrayModel<MaterialCheckModel>('PartSet', []));

        this.frontId = <TextModel>this.set(new TextModel('FrontId', configService.getUserFrontId()));

        if (clientManager.isNgmAP0()) {
            userMasterService.setSalesOrgAndPlantForModel(this);
        }
        if (clientManager.isNgmP58()) {
            this.longText = <ArrayModel<TextModel>>this.set(new ArrayModel('LtextSet', []));
        }
    }

    /**
     * This function adds the current material and its quantity to the PartSet model.
     */
    public addMaterialToPartSet(): void {
        const currentMaterial = new MaterialCheckModel(this.materialNumber.value, this.quantity.value ?? 0, '');
        this.partSet.addModel(currentMaterial);
        if (this.longText !== undefined) {
            this.longText.addModel(new TextModel('Material', this.materialNumber.value));
        }
        // reset input field
        this.materialNumber = new TextModel('MaterialNumber', '', this.materialNumber.options);
    }

    public deleteMaterialFromPartSet(index: number): void {
        this.partSet.removeModel(index);
        if (this.longText !== undefined) {
            this.longText.removeModel(index);
        }
    }
}
